import React, { Component } from 'react'
import compose from 'recompose/compose'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
// import Avatar from '@material-ui/core/Avatar'
import { withStyles } from '@material-ui/core/styles'
// import { Link } from 'react-router-dom'
// import { translate } from 'react-admin'
import dataProvider from '../../utils/dataProvider'
import { GET_LIST } from 'react-admin'
import moment from 'moment'
import LinearProgress from '@material-ui/core/LinearProgress'

const style = theme => ({
    root: {
        flex: 1,
    },
    avatar: {
        background: theme.palette.background.avatar,
    },
    cost: {
        marginRight: '1em',
        color: theme.palette.text.primary,
    },
})

class Notification extends Component {

    state = {
        notificaciones : []
    }

    componentDidMount(){
        const params = {
            pagination: {
                page: 1,
                perPage: 10
            },
            sort: {
                field: 'edited_date',
                order: 'DESC'
            },
        }
        dataProvider(GET_LIST, 'notificaciones', params)
        .then(res => {
            console.log(res)
            this.setState({
                notificaciones : res.data
            })
        })
        .catch(error => {
            console.error(error)
        })
    }

    render(){
        const { classes } = this.props
        const { notificaciones } = this.state

        return (
            <Card className={classes.root}>
                <CardHeader title={'Notificaciones'} />
                {notificaciones.length > 0 &&
                <List dense={true}>
                    {notificaciones.map(n => (
                    <ListItem key={n.id}>
                        <ListItemText
                            primary={moment(n.edited_date).format("DD-MM-YYYY hh:mm")}
                            secondary={n.comment}
                        />
                    </ListItem>
                    ))}
                </List>
                }
                {notificaciones.length === 0 && <LinearProgress />}
            </Card>
        )
    }

}

const enhance = compose(
    withStyles(style),
)

export default enhance(Notification)